<form class="content" [formGroup]="generalHistoryForm" (submit)="submit()">
  <span class="section-heading">{{ 'smoking' | translate }}</span>
  <div class="section-fields" formGroupName="smoking">
    <mat-form-field>
      <mat-label>{{ 'cigarettes_per_day' | translate }}</mat-label>
      <mat-select formControlName="value">
        <mat-option *ngFor="let option of options.smoking" [value]="option">
          {{ option | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'add_a_note_about_smoking' | translate }}</mat-label>
      <input matInput type="text" name="smoking-note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
  </div>
  <br />
  <span class="section-heading">{{ 'alcohol_consumption' | translate }}</span>
  <div class="section-fields" formGroupName="alcohol">
    <mat-form-field>
      <mat-label>{{ 'alcoholic_drinks_per_week' | translate }}</mat-label>
      <mat-select formControlName="value">
        <mat-option *ngFor="let option of options.alcohol" [value]="option">
          {{ option | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'add_a_note_about_alcohol' | translate }}</mat-label>
      <input matInput type="text" name="alcohol-note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
  </div>
  <span class="section-heading">{{ 'exercise' | translate }}</span>
  <div class="section-fields" formGroupName="exercise">
    <mat-form-field>
      <mat-label>{{ 'average_hours_exercise_per_week' | translate }}</mat-label>
      <mat-select formControlName="value">
        <mat-option *ngFor="let option of options.exercise" [value]="option">
          {{ option | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'add_a_note_about_exercise' | translate }}</mat-label>
      <input matInput type="text" name="exercise-note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
  </div>
  <span class="section-heading">{{ 'recreational_drug_use' | translate }}</span>
  <div class="section-fields" formGroupName="recreational_drugs">
    <mat-form-field>
      <mat-label>{{ 'select_recreational_drug_use_option' | translate }}</mat-label>
      <mat-select formControlName="value">
        <mat-option *ngFor="let option of options.recreationalDrugs" [value]="option">
          {{ option | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'add_a_note_about_recreational_drug_use' | translate }}</mat-label>
      <input matInput type="text" name="recreationl-drugs-note" formControlName="note" gcFormField gcFormFieldNoError />
    </mat-form-field>
  </div>
  <button
    mat-flat-button
    type="submit"
    [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
    [disabled]="generalHistoryForm.invalid"
    class="button-submit"
  >
    <mat-icon svgIcon="check"></mat-icon>
    {{ 'save_general_history' | translate }}
  </button>
</form>
